<style scoped>
    .expand-row {
        margin-bottom: 16px;
        margin-left: 40px;
        text-align: left;
    }

    .expand-key {
        margin-left: 16px;
        margin-right: 16px;
        font-weight: bold;
    }

    .expand-value {
        margin-right: 16px;
    }

    .expand-panel {
        text-align: left;
    }
</style>
<template>
    <div>
        <div v-if="!row.repairHistoryNewMeterId">{{row.repairHistoryContent}}</div>
        <div v-if="row.repairHistoryNewMeterId">
            <Spin fix v-show="isInfoSpinShow">
                <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
                <div>Loading</div>
            </Spin>
            <Collapse simple>
                <Panel name="3" class="expand-panel">
                    旧设备表具
                    <div slot="content">
                        <Row class="expand-row">
                            <Col span="12">
                            <span class="expand-key">旧表表号：</span>
                            <span class="expand-value">{{ infoMeter.meterId }}</span>
                            </Col>
                            <Col span="12">
                            <span class="expand-key">通讯方式：</span>
                            <span class="expand-value">{{ infoMeter.meterCommunicationMode }}</span>
                            </Col>
                            <Col span="12">
                            <span class="expand-key">表厂家：</span>
                            <span class="expand-value">{{ infoMeter.meterManufacturer }}</span>
                            </Col>
                            <Col span="12">
                            <span class="expand-key">表规格：</span>
                            <span class="expand-value">{{ infoMeter.meterSpecifications }}</span>
                            </Col>
                            <Col span="12">
                            <span class="expand-key">表底数：</span>
                            <span class="expand-value">{{ infoMeter.meterBaseNumber }}</span>
                            </Col>
                            <Col span="12">
                            <span class="expand-key">设备类型：</span>
                            <span class="expand-value">{{ meterTypeList[infoMeter.meterType] }}</span>
                            </Col>
                            <Col span="12" v-if="meterType.indexOf('工况流量') != -1">
                            <span class="expand-key">剩余工况流量（m³）：</span>
                            <span class="expand-value">{{ infoMeter.remainFlow }}</span>
                            </Col>
                            <Col span="12" v-if="meterType.indexOf('标况流量') != -1">
                            <span class="expand-key">剩余标况流量（m³）：</span>
                            <span class="expand-value">{{ infoMeter.remianFlowStandard }}</span>
                            </Col>
                            <Col span="12" v-if="meterType.indexOf('金额') != -1">
                            <span class="expand-key">剩余金额（元）：</span>
                            <span class="expand-value">{{ infoMeter.remainMoney }}</span>
                            </Col>
                        </Row>
                    </div>
                </Panel>
                <Panel name="3" class="expand-panel">
                    新设备表具
                    <div slot="content">
                        <Row class="expand-row">
                            <Col span="12">
                            <span class="expand-key">新表表号：</span>
                            <span class="expand-value">{{ row.repairHistoryNewMeterId }}</span>
                            </Col>
                            <Col span="12">
                            <span class="expand-key">通讯方式：</span>
                            <span class="expand-value">{{ row.repairHistoryRemark }}</span>
                            </Col>
                            <Col span="12">
                            <span class="expand-key">表厂家：</span>
                            <span class="expand-value">{{ row.repairHistoryNewMeterManufacturer }}</span>
                            </Col>
                            <Col span="12">
                            <span class="expand-key">表规格：</span>
                            <span class="expand-value">{{ row.repairHistoryNewMeterSpecifications }}</span>
                            </Col>
                            <Col span="12">
                            <span class="expand-key">表底数：</span>
                            <span class="expand-value">{{ row.repairHistoryNewMeterBaseNumber }}</span>
                            </Col>
                            <Col span="12">
                            <span class="expand-key">设备类型：</span>
                            <span class="expand-value">{{ meterTypeList[row.repairHistoryNewMeterType] }}</span>
                            </Col>
                        </Row>
                    </div>
                </Panel>
            </Collapse>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            row: Object,
            type: ""
        },
        mounted() {
            console.log(this.meterTypePayTypeList);
            
            if(this.row.repairHistoryNewMeterId){
                let that = this;
                that.isInfoSpinShow = true;
                $.ajax({
                    url: "/api/InfoMeter/selectByPrimaryKey",
                    contentType: "application/json",
                    type: "post",
                    data: JSON.stringify({
                        meterId: that.row.repairHistoryMeterId
                    }),
                    dataType: "json",
                    success: function(data) {
                        if (data.errorCode != 0) {
                            that.$Notice.error({
                                title: "异常",
                                desc: data.errorInfo
                            });
                            return;
                        }
                        that.infoMeter = data.body;
                        that.infoMeter.commandObject = JSON.parse(data.body.command.commandContent);
                        that.infoMeter.remainFlow = that.infoMeter.commandObject.service.data.remainFlow / 1000;
                        that.infoMeter.remianFlowStandard = that.infoMeter.commandObject.service.data.remianFlowStandard /
                            1000;
                        that.infoMeter.remainMoney = that.infoMeter.commandObject.service.data.remainMoney /
                            100;
                        that.meterType = that.meterTypePayTypeList[that.infoMeter.meterType];
                    },
                    error: function(textStatus) {
                        that.$Notice.error({
                            title: "异常",
                            desc: "接口请求异常"
                        });
                    },
                    complete: function() {
                        that.isInfoSpinShow = false;
                    }
                });
            }
        },
        data() {
            return {
                isInfoSpinShow: false,
                infoMeter: {},
                meterTypeList: global.meterType,
                meterTypePayTypeList: global.meterTypePayType,
                meterType: ""
            }
        }
    };
</script>
